import {WARNING_TAG_EXPLANATION, WARNING_TAG_TEXT} from "../../utils/rowWarnings.ts";

export function RowWarningTag() {
    return (
        <span
            title={WARNING_TAG_EXPLANATION}
            className="ml-2 inline-flex items-center rounded-[4px] bg-amber-50 px-1.5 py-0.5 text-[9px] font-semibold text-amber-700 ring-1 ring-inset ring-amber-200"
        >
            {WARNING_TAG_TEXT}
        </span>
    );
}
